import type { BillOut } from "../../../../../api/bills";
import { lineTotal, roundToCent } from "../discounts/itemDiscountMath";
import { effectiveAmount, requestedBillDiscount } from "../discounts/billAmountDiscount";

/**
 * Сумата на сметката, ако ѝ се закачи клиент с този (знаков) процент —
 * огледало на BE `apply_bill_discount`: всеки ред и добавка — по
 * `row_total` (`itemDiscountMath.lineTotal`), редовете със заключена цена
 * остават на цената си. За обобщението „35.90 → 26.92" в „Клиенти";
 * записва сървърът. Отстъпката в € на цялата сметка остава и се вади от
 * новия сбор — не повече от него, и редовете със заключена цена влизат (BE
 * `service_bill_discount.effective_bill_discount`).
 */
export function billTotalAtClientPercent(
  bill: Pick<BillOut, "elements" | "bill_discount_amount">,
  percent: number,
): number {
  let total = 0;
  for (const element of bill.elements) {
    for (const item of element.items) {
      const lines = [
        { price: parseFloat(item.price), quantity: parseFloat(item.quantity) },
        ...item.additions.map((addition) => ({
          price: parseFloat(addition.price),
          quantity: parseFloat(addition.quantity),
        })),
      ];
      for (const line of lines) {
        const value = item.locked_price
          ? roundToCent(line.price * line.quantity)
          : lineTotal(line.price, line.quantity, percent, false);
        total += value;
      }
    }
  }
  const billDiscount = effectiveAmount(requestedBillDiscount(bill), roundToCent(total));
  return roundToCent(total - billDiscount);
}
